import { Flex, Typography } from 'antd';
import { UserAvatar } from '../UserAvatar/UserAvatar';

const { Text } = Typography;

/** Minimal shape shared by every user/author embed (praise users, idea authors, …). */
type PersonLike = {
  displayName: string;
  avatarUrl: string | null;
};

type Props = {
  user: PersonLike | null | undefined;
  /** Shown when `user` is absent (e.g. anonymous idea authors). */
  fallback?: string;
  /** When false, render the full name on one line instead of truncating it. Defaults to true. */
  ellipsize?: boolean;
};

/**
 * Table cell rendering an avatar beside a display name. The name is ellipsized by default; pass
 * `ellipsize={false}` to always show it in full. When `user` is null/undefined it renders the
 * `fallback` label instead (defaults to "Anonymous").
 */
export const PersonCell = ({ user, fallback = 'Anonymous', ellipsize = true }: Props) => {
  if (!user) return <Text type="secondary">{fallback}</Text>;
  return (
    <Flex align="center" gap={8} style={{ maxWidth: '100%' }}>
      <UserAvatar size={24} avatarUrl={user.avatarUrl} />
      {ellipsize ? (
        <Text ellipsis style={{ maxWidth: 120 }} title={user.displayName}>
          {user.displayName}
        </Text>
      ) : (
        <Text style={{ whiteSpace: 'nowrap' }}>{user.displayName}</Text>
      )}
    </Flex>
  );
};
